import { common } from '@libs/domain';
import { Item } from '@ps-smart-cp/ppfw-client';

const importFieldConfig = {
  file: Item.of(common.names.file, common.attributes.file),
  characterCode: Item.of(common.names.characterCode, common.attributes.characterCode),
};

const csvColumnSettingConfig = {
  csvColumnSettingMethod: Item.of(
    common.names.csvColumnSettingMethod,
    common.attributes.csvColumnSettingMethod.replaceRequired(true),
  ),
};

export { csvColumnSettingConfig, importFieldConfig };
